export default "__VITE_ASSET__DofR58BB__"